import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { View } from 'foundations-components/components/View';
import { PriceDisplay } from 'pricing-pages-ui-components/price/PriceDisplay';
import { SingleSkeletonLoader } from '../components/SingleSkeletonLoader';
import { useBestPriceForProducts } from '../hooks/useGrowthPurchaseOptions';
import { jsx as _jsx } from "react/jsx-runtime";
export const PriceByProductApiName = ({
  productApiName,
  showPerMonth = false
}) => {
  var _priceQuery$bestPrice;
  const priceQuery = useBestPriceForProducts({
    productsToPurchase: [{
      productApiName,
      quantity: 1
    }]
  });
  const price = (_priceQuery$bestPrice = priceQuery.bestPriceMap[productApiName]) === null || _priceQuery$bestPrice === void 0 ? void 0 : _priceQuery$bestPrice.monthlyPrice;
  const currencyCode = priceQuery.currencyCode;
  if (priceQuery.loading) {
    return /*#__PURE__*/_jsx(SingleSkeletonLoader, {
      height: 40,
      width: 175
    });
  }
  if (priceQuery.error || !price) {
    return /*#__PURE__*/_jsx(View, {
      blockSize: "40px",
      inlineSize: "175px"
    });
  }
  if (showPerMonth) {
    return /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "priceComponents.pricePerMonth",
      options: {
        price: /*#__PURE__*/_jsx(PriceDisplay, {
          price: price,
          currencyCode: currencyCode
        })
      }
    });
  }
  return /*#__PURE__*/_jsx(PriceDisplay, {
    price: price,
    currencyCode: currencyCode
  });
};